import { useEffect, useState } from "react";

/**
 * useCookie - 获取 cookie 中指定字段的值
 * @param name cookie字段名
 * @returns 字段值或 undefined
 */
export function useCookie(name: string) {
  const getCookie = (name: string): string | undefined => {
    if (typeof document === "undefined") return undefined;
    const match = document.cookie.match(new RegExp('(?:^|; )' + encodeURIComponent(name) + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : undefined;
  };

  const [value, setValue] = useState<string | undefined>(() => getCookie(name));

  // 可选：监听cookie变化（如有需要可扩展）
  useEffect(() => {
    const newValue = getCookie(name);
    if (newValue !== value) {
      setValue(newValue);
    }
  }, [name, value]);

  return value;
} 